module.exports = {
    CHOICE_ALGO_A: 'ALGO_A',
    CHOICE_ALGO_B: 'ALGO_B',
};
